import React, { useEffect, useState } from "react";
import SidebarLogo from "../common/logo";
import MenuLabel from "../common/menu-label";
import SingleMenuItem from "./single-menu-item";
import SubMenuHandler from "./sub-menu-handler";
import NestedSubMenu from "../common/nested-menus";
import AddBlock from "../common/add-block";
import { cn, isLocationMatch } from "../../../../helper/utilityHelper";
import { useSidebar } from "../../../../store";
import { ScrollArea } from "../../../ui/scroll-area";
import { useLocation } from "react-router-dom";
import Common from "../../../../helper/common";
import { getMenuConfig } from "../../../../config/menus";
import { ClubPrivacyTypeEnum } from "../../../../constants/appConstant";
import { useQueryParams } from "../../../../contexts/queryParamsContext";

const ClassicSidebar = () => {

  const { sidebarBg } = useSidebar();
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [activeMultiMenu, setMultiMenu] = useState(null);
  const [menus, setMenus] = useState([]);
  const { collapsed, setCollapsed } = useSidebar();
  const [hovered, setHovered] = useState(false);

  const { params } = useQueryParams();

  useEffect(() => {
    (async () => {
      let user = Common.getUser();

      setMenus(
        getMenuConfig(
          user?.userType,
          params.myClub?.privacyType == ClubPrivacyTypeEnum.Private
        )?.sidebarNav?.classic || []
      );
    })();
  }, [params]);

  const toggleSubmenu = (i) => {
    if (activeSubmenu === i) {
      setActiveSubmenu(null);
    } else {
      setActiveSubmenu(i);
    }
  };

  const toggleMultiMenu = (subIndex) => {
    if (activeMultiMenu === subIndex) {
      setMultiMenu(null);
    } else {
      setMultiMenu(subIndex);
    }
  };
  const location = useLocation();
  const locationName = location.pathname;

  React.useEffect(() => {
    let subMenuIndex = null;
    let multiMenuIndex = null;
    menus?.map((item, i) => {
      if (item?.child) {
        item.child.map((childItem, j) => {
          if (isLocationMatch(childItem.href, locationName)) {
            subMenuIndex = i;
          }
          if (childItem?.multi_menu) {
            childItem.multi_menu.map((multiItem, k) => {
              if (isLocationMatch(multiItem.href, locationName)) {
                subMenuIndex = i;
                multiMenuIndex = j;
              }
            });
          }
        });
      }
    });
    setActiveSubmenu(subMenuIndex);
    setMultiMenu(multiMenuIndex);
  }, [locationName]);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={cn(
        "fixed z-[999] top-0 bg-card h-full hover:!w-[248px] border-r paddingleft6",
        {
          "w-[248px]": !collapsed,
          "w-[72px]": collapsed,
          "shadow-md": collapsed || hovered,
        }
      )}
    >
      <style>
        {`
          .paddingleft6 {
            padding-left: 6px!important;
          }

          @media screen and (max-width: 768px) {
            .paddingleft6 {
              padding-left: 0px !important;
            }
          }
        `}
      </style>

      {sidebarBg !== "none" && (
        <div
          className=" absolute left-0 top-0   z-[-1] w-full h-full bg-cover bg-center opacity-[0.07]"
          style={{ backgroundImage: `url(${sidebarBg})` }}
        ></div>
      )}

      <SidebarLogo hovered={hovered} />

      <ScrollArea
        className={cn("sidebar-menu h-[calc(100%-80px)]", {
          "px-4": !collapsed || hovered,
        })}
      >
        <ul
          className={cn(" space-y-1", {
            " space-y-2 text-center": collapsed,
            "text-start": collapsed && hovered,
          })}
        >
          {menus.map((item, i) => (
            <li key={`menu_key_${i}`}>
              {/* single menu  */}

              {!item.child && !item.isHeader && (
                <SingleMenuItem
                  item={item}
                  collapsed={collapsed}
                  hovered={hovered}
                />
              )}

              {/* menu label */}
              {item.isHeader && !item.child && (!collapsed || hovered) && (
                <MenuLabel item={item} />
              )}

              {/* sub menu */}
              {item.child && (
                <>
                  <SubMenuHandler
                    item={item}
                    toggleSubmenu={toggleSubmenu}
                    index={i}
                    activeSubmenu={activeSubmenu}
                    collapsed={collapsed}
                    hovered={hovered}
                  />

                  {(!collapsed || hovered) && (
                    <NestedSubMenu
                      toggleMultiMenu={toggleMultiMenu}
                      activeMultiMenu={activeMultiMenu}
                      activeSubmenu={activeSubmenu}
                      item={item}
                      index={i}
                      collapsed={collapsed}
                      hovered={hovered}
                    />
                  )}
                </>
              )}
            </li>
          ))}
        </ul>
        {!collapsed && (
          <div className="-mx-2 ">
            <AddBlock />
          </div>
        )}
      </ScrollArea>
    </div>
  );
};

export default ClassicSidebar;
